module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-breadcrumb', {
    staticClass: "bread",
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'orgManager'
      }
    }
  }, [_vm._v("组织管理")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("修改组织机构")])], 1), _vm._v(" "), _c('el-form', {
    ref: "orgForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.orgForm,
      "rules": _vm.actrules,
      "label-width": "150px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "组织机构名称",
      "prop": "orgName"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "placeholder": "组织机构名称"
    },
    model: {
      value: (_vm.orgForm.orgName),
      callback: function($$v) {
        _vm.$set(_vm.orgForm, "orgName", $$v)
      },
      expression: "orgForm.orgName"
    }
  })], 1), _vm._v(" "), (_vm.pidFlag) ? _c('el-form-item', {
    attrs: {
      "label": "上级组织机构",
      "prop": "orgLevel"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择上级组织机构",
      "disabled": true
    },
    model: {
      value: (_vm.pid),
      callback: function($$v) {
        _vm.pid = $$v
      },
      expression: "pid"
    }
  }, _vm._l((_vm.orgList), function(item, index) {
    return _c('el-option', {
      attrs: {
        "label": item.org_name,
        "value": _vm.pid
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "组织机构级别",
      "prop": "orgLevel"
    }
  }, [_c('el-select', {
    staticClass: "m-1",
    attrs: {
      "placeholder": "请选择级别",
      "disabled": true
    },
    model: {
      value: (_vm.orgForm.orgLevel),
      callback: function($$v) {
        _vm.$set(_vm.orgForm, "orgLevel", $$v)
      },
      expression: "orgForm.orgLevel"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "一级组织机构",
      "value": "1"
    }
  }, [_vm._v("一级组织机构")]), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "二级组织机构",
      "value": "2"
    }
  }, [_vm._v("二级组织机构")]), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "三级组织机构",
      "value": "3"
    }
  }, [_vm._v("三级组织机构")]), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "四级组织机构",
      "value": "4"
    }
  }, [_vm._v("四级级组织机构")])], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "id": "primary",
      "disabled": _vm.isorgsubmit
    },
    on: {
      "click": function($event) {
        _vm.submitForm()
      }
    }
  }, [_vm._v("保 存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_vm._v("关闭")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-45036c58!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/org/OrgModify.vue
// module id = 1058
// module chunks = 2